// extracted by mini-css-extract-plugin
module.exports = {"checklist":"a10a3f92e9--checklist--3afnR","item":"a10a3f92e9--item--3RgsV"};